import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id", "placeholder", "value"]
const _hoisted_2 = {
  key: 0,
  class: "p-0 mb-1 mt-1 text-sm text-red-400"
}

import { makeFakeID } from "@/utils";
	import { watch, ref, onMounted, onBeforeMount } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TextAreaTag',
  props: {
		placeholder: {
			type: String,
			default: "Change the placeholder",
		},
		css: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: "",
		},
		error: {
			type: String,
			default: "",
		},
	},
  emits: ["model"],
  setup(__props) {

	const event = new Event("input");
	const inputTag = ref<any>(null);
	const inputTagID = ref<any>(makeFakeID(5));
	

	const props = __props;

	watch(
		() => props.value,
		() => {
			// Dispatch the INPUT event.
			if (props.value != "") {
				inputTag.value.value = props.value;
				inputTag.value.dispatchEvent(event);
			}
		}
	);

	onMounted(async () => {
		// Initialisation
		inputTag.value = await document.querySelector("textarea[id=" + inputTagID.value + "]");
		// Dispatch the INPUT event.

		if (props.value != "") {
			inputTag.value.dispatchEvent(event);
		}
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
			__props.css,
			{
				'flex flex-col pl-2 pr-1 py-2 space-x-2 bg-transparent border rounded-lg border-secondary': true,
			},
		])
    }, [
      _createElementVNode("textarea", {
        class: "w-full text-white bg-transparent outline-none focus:outline-none placeholder-secondary autofill:bg-green-800",
        id: inputTagID.value,
        placeholder: __props.placeholder,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('model', $event.target?.value))),
        value: __props.value
      }, "\n\t\t", 40, _hoisted_1)
    ], 2),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})